import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";

var Authorized = function Authorized(_ref) {
  var props = _extends({}, _ref);

  var currentUser = props.currentUser,
      authLoading = props.authLoading;
  var router = useRouter();

  if (true && !authLoading && !currentUser) {
    router.push("/login?redirect=".concat(encodeURIComponent(window.top.location.toString())));
  }

  return /*#__PURE__*/_jsx("div", {
    className: "h-full",
    children: props.children
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.auth.users.current,
    authLoading: state.auth.loading
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Authorized);